module.exports = __webpack_public_path__ + "img/location.0ba289b8.png";